<template>
  <div class="jobView column">
    <Header />
    <Button layout="back" @click="router.back()" class="show-s">
      <i class="fa fa-arrow-left"></i> Voltar
    </Button>
    <div class="content">
      <Job />
    </div>
     <Telegram />
  </div>
</template>

<script>
import Header from "@/components/HeaderSupporter.vue";
import Job from "@/components/Job.vue";
import Button from "@/components/Button.vue";
import Router from "@/router";
import Telegram from "@/components/Telegram.vue";

export default {
  name: "JobView",
  components: {
    Header,
    Job,
    Button,
    Telegram
  },
  data() {
    return {
      router: Router
    };
  }
};
</script>

<style lang="sass">
@use "@/assets/scss/vars.scss" as *
.jobView
  input, textarea, select
    height: 44px
    padding: 0 8px
    border: none
    width: 92%
    border-bottom: 3px solid #ddd
    border-radius: 8px
    box-shadow: none
    background: none
    &:focus
      background: rgba($purple,.1)
      border-bottom: 3px solid $purple
  textarea
    min-height: 160px
    padding-top: 12px
  input[type='checkbox']
    width: 18px
    height: 18px
</style>
<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.jobView {
  .content {
    padding: 42px 35px;
    @media (max-width: $small) {
      padding: 7px;
    }
  }
}
</style>
